import { render, staticRenderFns } from "./Sign_up.vue?vue&type=template&id=0e0c7d87"
import script from "./Sign_up.vue?vue&type=script&lang=js"
export * from "./Sign_up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports